module.exports = __webpack_public_path__ + "img/team-10.8c89b6ed.jpg";